exports = module.exports = require("../../../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".TextPlayer-module__example___1NsIk{display:grid;gap:1em;grid-auto-flow:column;grid-template-columns:auto 1fr;align-items:center;background-color:#f7f0e2;padding:1em;border-radius:4px}.TextPlayer-module__text___kzNYy{color:#707070;font-size:14px;font-family:neue-haas-grotesk-display,sans-serif;background:none;border:none;display:block;width:100%;resize:none}", ""]);

// exports
exports.locals = {
	"example": "TextPlayer-module__example___1NsIk",
	"text": "TextPlayer-module__text___kzNYy"
};